module.exports = __webpack_public_path__ + "static/media/x_dark.1c4b31c7.svg";